<div id="chat-log"></div>
<div id="chat-controls">
    <input type="text" id="active-message" />
    <button id="send-message" disabled="true">Send Message</button>
    <audio autoplay></audio>
</div>